import type { KnownStates } from './DevPanel.types';

export const KNOWN_STATES: KnownStates = {
  LOADING: 'loading',
  ERROR: 'error',
  EMPTY: 'empty',
  ZERO: 'zero',
  DATA: 'data',
  NONE: 'none',
};

const EMPTY_STATE = {
  name: 'Empty',
  label: 'Empty',
  id: KNOWN_STATES.EMPTY,
  value: KNOWN_STATES.EMPTY,
  description: 'No data is available to display',
};

const ZERO_STATE = {
  name: 'Zero',
  label: 'Zero',
  id: KNOWN_STATES.ZERO,
  value: KNOWN_STATES.ZERO,
  description: 'No data is available to display',
};

export const COMMON_STATES = [
  {
    name: 'None',
    label: 'None',
    id: KNOWN_STATES.NONE,
    value: KNOWN_STATES.NONE,
    description: 'No state selected',
  },
  {
    name: 'Data',
    label: 'Data',
    id: KNOWN_STATES.DATA,
    value: KNOWN_STATES.DATA,
    description: 'View feature with data loaded',
  },
  {
    name: 'Loading',
    label: 'Loading',
    id: KNOWN_STATES.LOADING,
    value: KNOWN_STATES.LOADING,
    description: 'View feature with loading state',
  },
  {
    name: 'Error',
    label: 'Error',
    id: KNOWN_STATES.ERROR,
    value: KNOWN_STATES.ERROR,
    description: 'View feature with error state',
  },
];

export const JUMP_BACK_IN_STATES = [
  ...COMMON_STATES,
  {
    ...EMPTY_STATE,
    description: 'View feature with no user activity available',
  },
  {
    ...ZERO_STATE,
    description: 'View feature with no user activity that match the selected filters',
  },
];

export const ALERTS_STATES = [
  ...COMMON_STATES,
  {
    ...EMPTY_STATE,
    description: 'View feature with no recent alerts triggered',
  },
  {
    ...ZERO_STATE,
    description: 'View feature with no project alerts configured and no recent alerts triggered',
  },
];

export const SEND_METRICS_STATES = [
  ...COMMON_STATES,
  {
    ...ZERO_STATE,
    description: 'View feature with no campaigns that match the selected filters',
  },
];

export const GOALS_STATES = [
  ...COMMON_STATES,
  {
    ...EMPTY_STATE,
    description: 'View feature with no goals available',
  },
];
